<section *ngIf="displayName">
    <div *ngIf="stateActive(pageData)" class="active-state"></div>
    <div class="avatar">
        <div class="dot"></div>
        <p class="first-char">{{ displayNameFirstCharacter }}</p>
    </div>
    <div>
        <p class="name">{{ pageData.welcomeMessage }} <span data-notranslate>{{ displayName }}</span></p>
        <a class="my-account" [uiSref]="pageData.uiSref" [uiParams]="generateUiParams(pageData.uiParams)" (click)="closeMobileNav()">{{ pageData.name }}</a>
        <div *ngIf="isBusinessUser && account" class="account-info">
            <p>#{{account.cableAccountNumber}}</p>
            <p>{{ serviceAddress.address1 }}</p>
            <p *ngIf="serviceAddress.address2">{{ serviceAddress.address2 }}</p>
            <p>{{ serviceAddress.city }}, {{ serviceAddress.state }} {{ serviceAddress.zip }}</p>
        </div>
    </div>
</section>
